const persistableModelsHash = import.meta.glob(["./persistable/*.js", "./persistable/uvc/**/*.js", "!./model.js", "!./get-model.js", "!./require-models-*.js", "!./session-*.js"], { import: "default", eager: true });

export default persistableModelsHash;
